export enum LoadStatus {
  CREATED = 'CREATED',
  VALIDATING = 'VALIDATING',
  VALIDATED = 'VALIDATED',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  PROCESSING = 'PROCESSING',
  MATERIALIZING = 'MATERIALIZING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export interface ReportLoad {
  loadId: string;
  policyNumber: string;
  status: LoadStatus;
  statusDescription: string;
  operation: string;
  operationCode: string;
  createdAt: string | Date;
  totalRecords: number;
  processedRecords: number;
  errorCount: number;
  message?: string;
}

export interface ReportLoadPage {
  items: ReportLoad[];
  totalRecords: number;
}
